import PropTypes from 'prop-types';
import React from 'react';

import { Checkbox } from 'common-src/components/base';

import AwscCallItem from './AwscCallItem';
import styles from './Conversations.module.scss';
import VideoCallItem from './VideoCallItem';

const Conversations = ({
  hasRelevantConversations,
  setHasRelevantConversations,
  awscCallIds,
  setAwscCallIds,
  awscCalls,
  clients,
  videoCallIds,
  setVideoCallIds,
  videoCalls,
}) => (
  <>
    <p className={[styles.header, 'font-w-500', 'font-s-14'].join(' ')}>
      Please link this note to any recent conversations. Include all tasks, including reminders,
      that were associated with this note.
    </p>
    {awscCalls.map((call) => (
      <AwscCallItem
        key={call.id}
        call={call}
        awscCallIds={awscCallIds}
        setAwscCallIds={setAwscCallIds}
        relatedClients={clients}
      />
    ))}
    {videoCalls.map((videoCall) => (
      <VideoCallItem
        key={videoCall.id}
        videoCall={videoCall}
        videoCallIds={videoCallIds}
        setVideoCallIds={setVideoCallIds}
        relatedClients={clients}
      />
    ))}
    <Checkbox
      id="relevant-conversations"
      classNames={[styles.checkbox, 'm-t-16']}
      label="I don't see relevant conversations"
      checked={hasRelevantConversations}
      onChange={setHasRelevantConversations}
    />
  </>
);

Conversations.propTypes = {
  hasRelevantConversations: PropTypes.bool,
  setHasRelevantConversations: PropTypes.func,
  awscCallIds: PropTypes.array,
  setAwscCallIds: PropTypes.func,
  awscCalls: PropTypes.arrayOf(PropTypes.object),
  clients: PropTypes.arrayOf(PropTypes.object),
  videoCallIds: PropTypes.array,
  setVideoCallIds: PropTypes.func,
  videoCalls: PropTypes.arrayOf(PropTypes.object),
};

export default Conversations;
